var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTtd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1545 1539",
    width: 1545,
    height: 1539,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TTD_BIG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #0c0c27 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m417.7 1116.5v335.2c-247.6-128.6-417.1-386.6-417.1-684.6 0-108.5 22.9-213.3 64.8-306.6h315.1c-66.6 83.8-106.6 191.4-106.6 306.6 0 136.2 54.3 259.9 143.8 349.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m1544 767.1c0 426.6-345.6 771.2-771.2 771.2-46.6 0-92.3-4.7-136.1-12.3v-280c42.8 12.4 88.5 18.1 136.1 18.1 275.2 0 498.9-222.8 498.9-498 0-136.1-56.1-260.8-145.6-350.3v-333.3c248.5 127.6 417.9 386.6 417.9 685.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s0",
    d: "m340.5 0.6v273.3h296.2v589.4h273.2v-862.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtd);
export default __webpack_public_path__ + "static/media/ttd.cde975c994c713b1e8698af51e4ea806.svg";
export { ForwardRef as ReactComponent };